var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dc-stepper"},[_vm._l((_vm.steps),function(step,index){return [_c('dc-step',{key:`step-${index}`,attrs:{"step":step},on:{"is-active":_vm.setActive}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }